import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getViewObjectsForAsset,
	getViewObjectsForAssetEndpoint,
	type QueryError,
	type GetViewObjectsForAssetResult,
	type GetViewObjectsForAssetRequestOptions,
} from '../getViewObjectsForAsset';

export type GetViewObjectsForAssetQueryParams =
	GetViewObjectsForAssetRequestOptions;
export type GetViewObjectsForAssetQueryKey = [
	string,
	GetViewObjectsForAssetQueryParams,
];

export const GetViewObjectsForAssetReactQueryKey =
	getViewObjectsForAssetEndpoint;

export type GetViewObjectsForAssetReactQueryOptions = Omit<
	UseQueryOptions<
		GetViewObjectsForAssetResult,
		QueryError,
		GetViewObjectsForAssetResult,
		GetViewObjectsForAssetQueryKey
	>,
	'queryKey' | 'queryFn'
>;

/**
 * react-query wrapper for `getViewObjectsForAsset`
 * @param queryKeyParams Params passed to the api call
 * @param options Options passed to `useQuery`
 */
export const useGetViewObjectsForAssetReactQuery = (
	queryKeyParams: GetViewObjectsForAssetQueryParams,
	options?: GetViewObjectsForAssetReactQueryOptions,
) => {
	const getViewObjectsForAssetQuery = useQuery<
		GetViewObjectsForAssetResult,
		QueryError,
		GetViewObjectsForAssetResult,
		GetViewObjectsForAssetQueryKey
	>({
		queryKey: [getViewObjectsForAssetEndpoint, queryKeyParams],
		queryFn: ({signal}) => getViewObjectsForAsset(queryKeyParams, signal),
		refetchOnWindowFocus: false,
		...options,
	});
	return getViewObjectsForAssetQuery;
};

export default useGetViewObjectsForAssetReactQuery;
